import { BucketTypeEnum } from '@monetize/types/app';
import { objectToSelectOptions } from '@monetize/utils/core';

export const BUCKET_TYPE_ENUM_DISPLAY: {
  [key in BucketTypeEnum]: string;
} = {
  [BucketTypeEnum.TOKEN]: 'Token',
  [BucketTypeEnum.CASH]: 'Cash',
};

export const BucketStatusSelectOptions = objectToSelectOptions(
  BUCKET_TYPE_ENUM_DISPLAY,
);

export const NEW_BUCKET_OPTION = {
  name: '+ New Bucket',
  value: 'NEW_BUCKET',
};
